var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { loading } from '../../../elements/Loading';
import { Table } from '../../../components';
import history from '../../../helpers/History';
var SchedulesTable = /** @class */ (function (_super) {
    __extends(SchedulesTable, _super);
    function SchedulesTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelectItem = function (value) {
            history.push("/schedules/".concat(value.id));
        };
        _this.handleCreate = function () {
            history.push("/schedules/create");
        };
        return _this;
    }
    SchedulesTable.prototype.render = function () {
        var schedules = this.props.schedules;
        var scheduleStore = this.props.store.scheduleStore;
        var headers = ['hours', 'minutes'];
        return (React.createElement(Table
        /*items={operationLines.data}*/
        , { 
            /*items={operationLines.data}*/
            items: schedules, header: headers, onSelectItem: this.handleSelectItem, onCreate: this.handleCreate, keyExtractor: function (item) { return String(item.id); }, loading: !scheduleStore.loaded }));
    };
    SchedulesTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.scheduleStore.read().then(function (schedules) { return ({ schedules: schedules }); }),
            ];
        }),
        observer
    ], SchedulesTable);
    return SchedulesTable;
}(Component));
export default SchedulesTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Schedules/containers/SchedulesTable.tsx
// module id = 1547
// module chunks = 0